<div>
  <div>
    <div>
      <ul class="navbar-left-tabs">
        <li [class.selected]="leftNav?.tab == 'menu'">
          <a (click)="clickTab('menu')">Menu</a>
        </li>
        <li [class.selected]="leftNav?.tab == 'search'">
          <a (click)="clickTab('search')">Search</a>
        </li>
      </ul>
    </div>
    <div [ngSwitch]="leftNav?.tab">
      <div *ngSwitchCase="'menu'" class="left-nav-menu">
        <ul *ngFor="let area of leftNav?.children" class="navbar-left-area">
          <li [class.selected]="area.selected">
            <a (click)="clickArea(area.key)">
              <img [src]="'./assets/images/' + area.icon + '.svg'" alt="area-menu" [height]="area.key == 'invoices' || area.key == 'reporting' ? '20' : '24' " class="filter-invert" />
              <span style="padding-left: 12px">{{area.label}}</span>
              <span *ngIf="area.key !== 'reporting'"> ({{getTotalCount(area.key)}})</span>
            </a>
          </li>
          <ng-container *ngIf="area.selected && area.children != null && area.children.length > 0">
            <ng-container *ngFor="let child of area.children">
              <ng-container *ngIf="area.key === 'invoices' || area.key === 'tenders' || area.key === 'ready_to_audit'">
                <li class="child" [class.selected]="child.selected">
                  <div class="all-invoice-main">
                    <a (click)="toggleChild(child,true)" [class.ready-to-audit-child]="area.key === 'ready_to_audit'">
                      <img [src]="'./assets/images/' + child.icon + '.svg'" height="20" alt="child-menu" class="filter-invert child-icons" />
                      <span style="padding-left: 8px;">
                        {{child.label}}
                        <i *ngIf="child.children && child.children.length > 0 && (!!child.isOpen) && area.key != 'tenders' && area.key != 'ready_to_audit'"
                           class="fa fa-arrow-up"></i>
                        <i *ngIf="child.children && child.children.length > 0 && !(!!child.isOpen) && area.key != 'tenders' && area.key != 'ready_to_audit'"
                           class="fa fa-arrow-down"></i>
                        <span> ({{getTotalCount(child.key)}})</span>
                      </span>
                    </a>
                  </div>
                </li>
              </ng-container>
              <ng-container *ngIf="area.key != 'invoices' && area.key != 'tenders' && area.key != 'ready_to_audit'">
                <ng-container *ngIf="child.key === 'weekly_reporting'">
                  <li class="child" [class.selected]="child.selected">
                    <div>
                      <a  (click)="toggleChild(child,false)">
                        <img [src]="'./assets/images/' + child.icon + '.svg'" height="20" alt="child-menu" class="filter-invert" />
                        <span style="padding-left: 8px;">{{child.label}}</span>
                      </a>
                    </div>
                  </li>
                </ng-container>
                <ng-container *ngIf="child.key !== 'weekly_reporting'">
                  <li class="child" [class.selected]="child.selected">
                    <div>
                      <a (click)="toggleChild(child,false)">
                        <img [src]="'./assets/images/' + child.icon + '.svg'" height="20" alt="child-menu"  class="filter-invert" />
                        <span style="padding-left: 8px;">{{child.label}}</span>
                        <span *ngIf="child.key !== 'weekly_reporting'"> ({{getTotalCount(child.key)}})</span>
                      </a>
                    </div>
                  </li>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="child.children && child.children.length > 0 && child.isOpen">
                <ul class="left-nav-invoice" *ngFor="let subChild of child.children">
                  <li class="child" [ngClass]="area.key === 'users' ? 'pl-5 ml-2' : null" [class.selected]="subChild.selected">
                    <a (click)="toggleChild(subChild,true)" class="p-left" [class.order-field-child]="area.key === 'orders'">
                      <img *ngIf="subChild.key === 'invoice_needs_to_be_sent' " [ngClass]="'child-default-account-checkbox'" alt="child-menu"
                           [src]="'./assets/images/' + subChild.icon + '.svg'" height="20" class="filter-invert" />
                      <img *ngIf="subChild.key != 'invoice_needs_to_be_sent'" [ngClass]="subChild.key == 'customer_billing' || subChild.key == 'carrier_billing' ? 'child-default-account-receivable' : subChild.key == 'carrier_payments_on_hold' ? 'exclamation-spacing' : 'child-default'"
                      alt="child-menu" [src]="'./assets/images/' + subChild.icon + '.svg'" [height]="subChild.key == 'carrier_payments_on_hold' ||  subChild.key == 'customer_billing' || subChild.key == 'carrier_billing'? '16' : '20'" class="filter-invert" />
                      <span [ngClass]="area.key === 'users' ? 'pl-1' : 'pl-2'" >
                        {{subChild.label}}
                        <i *ngIf="subChild.children && subChild.children.length > 0 && (!!subChild.isOpen)" class="fa fa-arrow-up"></i>
                        <i *ngIf="subChild.children && subChild.children.length > 0 && !(!!subChild.isOpen)" class="fa fa-arrow-down"></i>
                      </span>
                      <span> ({{getTotalCount(subChild.key)}})</span>
                    </a>
                  </li>
                  <ng-container *ngIf="subChild.children && subChild.children.length > 0 && subChild.isOpen">
                    <ul class="left-nav-invoice" *ngFor="let secondChild of subChild.children">
                      <li class="child" [class.selected]="secondChild.selected" class="p-left">
                        <a (click)="clickArea(secondChild.key, true)" class="second-child-key" [class.order-field-child]="area.key === 'orders'">
                          <img [src]="'./assets/images/' + secondChild.icon + '.svg'" [height]="subChild.key == 'ach' || subChild.key == 'mail' ? '8' : subChild.key == 'carrier_billing' || subChild.key == 'customer_billing' ? '16' :'20'" class="filter-invert" [class.left-nav-bulleticon]="subChild.key == 'ach' || subChild.key == 'mail'" alt="child-menu" />
                          <span style="padding-left: 8px;" [class.secondchild-width]="secondChild.key == 'mail_ready_to_pay_over_the_next_week'" [class.ach-child-width]="secondChild.key == 'ach_ready_to_pay_over_the_next_week'">{{secondChild.label}}</span>
                          <span class="get-total-count"> ({{getTotalCount(secondChild.key)}})</span>
                        </a>
                      </li>
                    </ul>
                  </ng-container>
                </ul>
              </ng-container>
            </ng-container>
          </ng-container>
        </ul>
      </div>
      <div *ngSwitchCase="'search'"
           style="position: absolute; overflow-y: scroll; bottom: 56px; top: 115px; width: 363px;">
        <search-filter></search-filter>
      </div>
    </div>
    <div class="navbar-left-footer">
      <img src="./assets/images/signed-on-user.svg" alt="user" class="filter-invert" />
      {{userName}}
      <a *ngIf="isAdmin && sharedServiceClient.getPermissions('admin_dashboard')" (click)="admin()"><i class="fa fa-cog" alt="X" style="cursor: pointer"></i></a>
      <div class="link-button" style="float: right;">
        <a (click)="logout()">Logout</a>
      </div>
    </div>
  </div>
</div>
